<div class="centered-dialog">
    <form class="login" novalidate>
        <div class="logo-box"></div>
        <section>
            <h1 class="text-xl my-2">Ooops!</h1>
            <h4>Da ist wohl die Route kaputt.</h4>
        </section>
    </form>
</div>
